import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
const Checkbox = ({ checked: isChecked = false, label, labelPlacement = 'end', color = 'primary', name, size = 'medium', disabled = false, indeterminate = false, inputRef = null, onChange = undefined, // parent function refer to 'event.target.checked'
required = false, className = '', labelColor = 'secondary', }) => {
    const [checked, setChecked] = useState(isChecked);
    const handleChange = (event) => {
        setChecked(event.target.checked);
        if (onChange)
            onChange(event);
    };
    let inputSize = 'medium';
    let checkboxSx = {};
    // Adds our 'large' size functionality
    if (['small', 'medium'].includes(size)) {
        inputSize = size;
    }
    else if (size === 'large') {
        checkboxSx = { '& .MuiSvgIcon-root': { fontSize: 28 } };
    }
    return (_jsx(FormControlLabel, { className: className, label: label, sx: { color: `text.${labelColor}` }, labelPlacement: labelPlacement, "data-testid": "checkbox", control: (_jsx(MuiCheckbox, { checked: checked, color: color, disabled: disabled, indeterminate: indeterminate, inputProps: { 'aria-label': 'controlled' }, name: name, onChange: handleChange, ref: inputRef, required: required, size: inputSize, sx: checkboxSx })) }));
};
export default Checkbox;
//# sourceMappingURL=index.js.map